module.exports = __webpack_public_path__ + "sy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sy.svg
// module id = 826
// module chunks = 0